import React from 'react';

export default function ErrorComponent() {
  return (
    <div className="error">
      <p>City not found. Please check your entry is correct.</p>
    </div>
  );
}
